<template>
 <div>
  <div v-html="html"></div>
 </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDataTable, JtInput } from 'jtech-webcomps'
import NegotiationController from '../NegotiationController'
@Component({
  name: 'TermsSteep',
  components: {
    JtDataTable,
    JtInput
  },
  props: {
    consumerUnit: String,
    protocol: String
  }
})
class TermsSteep extends Vue {
  negotiationController = NegotiationController.getInstance()
  html = ''

  async mounted () {
    this.html = await this.negotiationController.getTermNegotiationHtml(this.consumerUnit)
  }
}

export default TermsSteep
</script>
<style lang="scss" scoped>
@import "tailwindcss/utilities";
</style>
